import { Globe } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator } from '@/components/ui/dropdown-menu';
import { useI18n } from '@/context/I18nContext';

export const LanguageSwitcher = ({ variant = 'ghost', size = 'sm', showLabel = false, testId = 'language-switcher' }) => {
    const { lang, setLang, langs, t } = useI18n();
    const current = langs.find(l => l.code === lang) || langs[0];
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant={variant} size={size} className="gap-1.5" data-testid={testId} aria-label={t('common.language','Idioma')}>
                    <Globe className="h-4 w-4" />
                    <span className="hidden sm:inline text-xs uppercase tracking-wide">{current.code}</span>
                    {showLabel ? <span className="text-xs text-muted-foreground">{current.label}</span> : null}
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-48">
                <DropdownMenuLabel>{t('common.language','Idioma')}</DropdownMenuLabel>
                <DropdownMenuSeparator />
                {langs.map(l => (
                    <DropdownMenuItem
                        key={l.code}
                        onClick={() => setLang(l.code)}
                        className={l.code === lang ? 'bg-secondary font-semibold' : ''}
                        data-testid={`language-option-${l.code}`}
                    >
                        <span className="mr-2">{l.flag}</span>{l.label}
                        <span className="ml-auto text-[10px] uppercase text-muted-foreground">{l.code}</span>
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
